import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

interface EnrollmentPercentageOverLastMonthResponse {
  currentMonth: number;
  lastMonth: number;
  percentageChange: number;
  changeType: 'increase' | 'decrease' | 'no-change';
}

export interface GetEnrollmentPercentageOverLastMonthParams {
  sessionId: string;
}

export const getEnrollmentPercentageOverLastMonthAPI = async (
  params: GetEnrollmentPercentageOverLastMonthParams,
) => {
  const response = await baseAPI.get<EnrollmentPercentageOverLastMonthResponse>(
    '/dashboard/metrics/active-classes/enrollment-percentage-over-last-month',
    {
      params,
    },
  );
  return response.data;
};

export const useGetEnrollmentPercentageOverLastMonth = (
  params: GetEnrollmentPercentageOverLastMonthParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [KEYS.ENROLLMENT_PERCENTAGE_OVER_LAST_MONTH, params.sessionId],
    queryFn: () => getEnrollmentPercentageOverLastMonthAPI(params),
    enabled: !!params.sessionId,
  });
};
